"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reduxAndTranslationRenderClient = void 0;
const tslib_1 = require("tslib");
const common_utils_1 = require("@as-react/common-utils");
const react_1 = require("react");
const client_1 = require("react-dom/client");
const utils_1 = require("./utils");
const logger_1 = require("@as-react/logger");
const rootMap = new Map();
const reduxAndTranslationRenderClient = (hypernovaRenderData, htmlNode, reactComponent, storeConfigurator, numeralInstance, dynamicStore, i18nTranslationResources) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    if (!(hypernovaRenderData === null || hypernovaRenderData === void 0 ? void 0 : hypernovaRenderData.context))
        return;
    hypernovaRenderData = (0, utils_1.enhanceHypernovaRendererData)(hypernovaRenderData, i18nTranslationResources);
    numeralInstance.changeLocal(hypernovaRenderData.context.aemConfiguration.locale);
    const reactComponentPromised = yield reactComponent.promisedComponent();
    let store = undefined;
    let routerHistory = undefined;
    if (reactComponent.hasReduxModule) {
        const dynamicStoreInstance = reactComponent.reduxStorePerInstance ? new common_utils_1.DynamicStore() : dynamicStore;
        const componentReduxModule = yield storeConfigurator.loadFromModuleCollection(reactComponent.componentName, (_a = hypernovaRenderData.store) !== null && _a !== void 0 ? _a : {});
        if (componentReduxModule.hasRouter) {
            routerHistory = (0, utils_1.generateHistoryObject)();
        }
        store = storeConfigurator.buildDynamic((_b = hypernovaRenderData.store) !== null && _b !== void 0 ? _b : {}, hypernovaRenderData.context, dynamicStoreInstance, componentReduxModule.modules, routerHistory);
    }
    const possibleWrappers = (0, utils_1.generatedNeededClientSideWrapperComponents)(hypernovaRenderData, routerHistory, store);
    const wrappedComponent = possibleWrappers.reduce((componentSoFar, { wrapper, additionalWrapperArguments }) => {
        return wrapper(componentSoFar, additionalWrapperArguments);
    }, reactComponentPromised.default);
    try {
        if (rootMap.has(htmlNode)) {
            (_c = rootMap.get(htmlNode)) === null || _c === void 0 ? void 0 : _c.unmount();
            rootMap.delete(htmlNode);
        }
    }
    catch (error) {
        logger_1.Logger.logError(error);
    }
    rootMap.set(htmlNode, (0, client_1.hydrateRoot)(htmlNode, (0, react_1.createElement)(wrappedComponent)));
    return true;
});
exports.reduxAndTranslationRenderClient = reduxAndTranslationRenderClient;
//# sourceMappingURL=reduxAndTranslation.rendererClient.js.map